module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoElEQVQoz52SsQnEMAxFf24CjZARMsKNoJEykIdI59bgDVKlCbgKuHrXxJAL4eD84TeSHogvDYBumiS9JZmkImmRlL4mgOYJWHjWcvYF6AoUfqs0UIBdgZzz5u6M44i7k3PebqAJmFslhLBL4u4Qwn4BZwEJoNZ6mBlPkJlRaz1OKKnhMcb1CWiOMa5t9qUe9a7XFURX5F3H/fuNhp6H/QB0hrmf9xmNSwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/assets/video_player/ticker.png
// module id = 180
// module chunks = 0